import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarUserActive = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.68 14.674c1.262-.423 2.928-.549 4.631-.549a.75.75 0 0 1 0 1.5c-1.672 0-3.134.13-4.154.471-.507.17-.849.375-1.057.591-.191.199-.293.428-.293.741 0 .314.102.546.293.746.208.218.548.424 1.053.596 1.018.346 2.48.48 4.158.48a.75.75 0 0 1 0 1.5c-1.713 0-3.38-.131-4.64-.56-.635-.216-1.222-.525-1.657-.98a2.51 2.51 0 0 1-.707-1.782 2.5 2.5 0 0 1 .712-1.78c.437-.454 1.026-.76 1.66-.974M11.31 4.75a3.245 3.245 0 1 0 0 6.49 3.245 3.245 0 0 0 0-6.49M6.563 7.996a4.745 4.745 0 1 1 9.491 0 4.745 4.745 0 0 1-9.49 0M19.473 14.759a.75.75 0 0 1 0 1.06l-3.4 3.402a.75.75 0 0 1-1.061 0l-1.65-1.654a.75.75 0 1 1 1.062-1.059l1.12 1.122 2.869-2.871a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarUserActive);
export default ForwardRef;
